"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurseSiphonEffectHandler = exports.CurseSiphonEffectArgs = void 0;
const enums_1 = require("../../enums");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class CurseSiphonEffectArgs {
    constructor(primaryAttribute, power, healingPercent) {
        this.primaryAttribute = primaryAttribute;
        this.power = power;
        this.healingPercent = healingPercent;
        this.__type = EffectType_1.EffectType.CurseSiphon;
        this.__typeName = "CurseSiphon";
        this.name = "Healing Curse";
        this.harmful = true;
    }
}
exports.CurseSiphonEffectArgs = CurseSiphonEffectArgs;
let CurseSiphonEffectHandler = class CurseSiphonEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerId = container.registerEventHandlerScript(state.targetId, state.duration.type === enums_1.DurationType.Ticks ? EventType_1.EventType.Tick
            : EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "Effect_CurseSiphon", {
            creatorId: state.creatorId,
            healingPercent: state.args.healingPercent,
            power: state.args.power,
            attributeType: state.args.primaryAttribute
        });
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
CurseSiphonEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.CurseSiphon)
], CurseSiphonEffectHandler);
exports.CurseSiphonEffectHandler = CurseSiphonEffectHandler;
